import * as React from 'react';
import { Progress as ProgressPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

type ProgressProps = React.ComponentProps<typeof ProgressPrimitive.Root> & {
    indeterminate?: boolean;
};

function Progress({ className, value, indeterminate = false, ...props }: ProgressProps) {
    return (
        <ProgressPrimitive.Root
            data-slot="progress"
            className={cn(
                'bg-muted relative flex h-1.5 w-full items-center overflow-x-hidden rounded-full',
                indeterminate && 'animate-progress origin-left',
                className,
            )}
            {...props}
        >
            <ProgressPrimitive.Indicator
                data-slot="progress-indicator"
                className="bg-primary size-full flex-1 transition-all"
                style={{ transform: indeterminate ? 'translateX(-0%)' : `translateX(-${100 - (value || 0)}%)` }}
            />
        </ProgressPrimitive.Root>
    );
}

export { Progress };
